import moment from 'moment-jalaali';

export function convertUnixToString(timestamp, format = 'dddd jDD-jMM-jYYYY') {
  return moment.unix(timestamp).format(format);
}

export function convertDateTimeToString(timestamp, format = 'dddd jDD-jMM-jYYYY') {
  return moment(timestamp).format(format);
}

export function formatDatetime(datetime, format = 'dddd jDD-jMM-jYY ساعت hh:mm') {
  return moment(datetime).format(format);
}
